<template>
  <div uk-grid>
    <div class="uk-width-1-4@s bg_gray">
      <div class="uk-section uk-padding-small">
        <div class="uk-text-center f26 uk-margin-large-top">
          <router-link :to="{ name: 'AdminForm' }" class="text_black">
            作成する
          </router-link>
        </div>
      </div>
    </div>
    <div class="uk-width-3-4@m uk-text-left">
      <div class="uk-container uk-container-small">
        <div class="uk-section">
          <ul class="uk-list">
            <li
              v-for="item in items"
              v-bind:key="item.id"
              class="uk-padding-small uk-margin-bottom bg_orange text_white scale f26 cut_edge_small uk-position-relative"
            >
              <router-link
                :to="{ name: 'AdminForm', params: { item_id: item.id } }"
                class="text_white"
              >
                {{ item.title }}
              </router-link>
              <span uk-icon="icon: trash" class="uk-position-center-right" @click="deleteConfirm(item.id)"></span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
import { mapActions } from 'vuex'
export default {
  created() {
    this.items = this.$store.state.items,
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.setLoginUser(user)
      } else {
        this.deleteLoginUser()
        this.$router.push({ name: 'Admin' }, () => {})
      }
    })
  },
  data() {
    return {
      login_user: this.$store.state.login_user,
    }
  },
  methods: {
    deleteConfirm (id) {
      if (confirm('削除してよろしいですか？')) {
        this.deleteItem({ id })
      }
    },
    ...mapActions(['setLoginUser', 'deleteLoginUser','deleteItem']),
  },
}
</script>

<style>
</style>